// window.tocAlreadyRun = false;
// const taster = new Adebugger();
// taster.debug = false;
// taster.version = "5.6";
// taster.trace = 0;
// taster.priority = 1;

function Adebugger() {
    this.debug = false;
    this.version = 1;
    this.priority = 1;
    this.trace = false;
    this.consoleTime = () => {
        let today = new Date();
        let hours = today.getHours();
        let minutes = today.getMinutes();
        let seconds = today.getSeconds();
        let ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        let strTime = hours + ":" + minutes + ":" + seconds + " " + ampm;
        console.log("Current Version is " + this.version);
    };

    /**TODO:
     * console.dir
     * console detect object and JSON Stringfy
     * * */
    this.log = (...$value) => {
        if (this.debug) {
            if (this.trace) {
                console.trace($value);
            } else {
                console.log($value);
            }
        }
    };
}

if (window.tocAlreadyRun) {
    console.log("Script already run. Exiting.");
} else {
    // Main script execution
    window.tocAlreadyRun = true;
    // Create an instance of Adebugger
    const taster = new Adebugger();
    taster.debug = false;
    taster.version = "5.6";
    taster.trace = 0;
    taster.priority = 1;
    const scriptsList = [
        "https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js",
        "https://cdnjs.cloudflare.com/ajax/libs/jquery-smooth-scroll/1.7.1/jquery.smooth-scroll.min.js",
        "https://cdn.jsdelivr.net/npm/sweetalert2@11",
        "https://notify.bestdecoders.com/js/toc-source.js",
        "https://notify.bestdecoders.com/js/check.js",
    ];

    loadScriptsSequentially(scriptsList, () => {
        const jQueryNoConflict = jQuery.noConflict(true);

        (($) => {
            $(document).ready(() => {
                //   taster.log(taster.debug);
                if (taster.debug || isArticleContext()) {
                    logIntroMessage();
                    if (taster.debug) {
                        addDefaultStyles();
                    }
                    loadSettingsAndInit();
                }
            });

            function isArticleContext() {
                return !(
                    typeof ShopifyAnalytics === "undefined" ||
                    ShopifyAnalytics.meta.page.pageType !== "article"
                );
            }

            function foldToc() {
                // Delegate click event from a static parent or document
                $("#easy-table-of-content").addClass("foldable");
                $(document).on(
                    "click",
                    "#easy-table-of-content li:has(> ul)",
                    function (event) {
                        event.stopPropagation();

                        $(this)
                            .siblings()
                            .find("> ul")
                            .slideUp()
                            .parent()
                            .removeClass("open");
                        $(this)
                            .find("> ul")
                            .first()
                            .slideToggle(function () {
                                $(this)
                                    .parent()
                                    .toggleClass(
                                        "open",
                                        $(this).is(":visible")
                                    );
                            });
                    }
                );

                $(document).on(
                    "click",
                    "#easy-table-of-content li > a, #easy-table-of-content.fixed li > span",
                    function (event) {
                        event.stopPropagation();
                        // Handle actions for main part of li click
                    }
                );

                // Initially hide all nested uls and show only the first ul element
                $("#easy-table-of-content ul").hide();
                $("#easy-table-of-content ul:first").show();
                $("#easy-table-of-content ul:first")
                    .parent("li")
                    .addClass("open");
            }

            // Optionally, you can call foldToc when the class 'fixed' is added
            // or in a $(document).ready() if the class might already be present.

            function logIntroMessage() {
                const style =
                    "color: tomato; background:#eee; -webkit-text-stroke: 1px black; font-size:30px;";
                console.log(
                    "%c  Hello! We're excited to introduce the latest and enhanced version of Easy Table Of Content. Dive into the updates and features by visiting https://notify.bestdecoders.com/docs/1.1/overview.",
                    style
                );
            }

            function addDefaultStyles() {
                const link = $("<link />", {
                    rel: "stylesheet",
                    type: "text/css",
                    href: " https://notify.bestdecoders.com/css/easy-table-of-content.css",
                });
                $("head").append(link);
            }

            function loadSettingsAndInit() {
                let oldData;
                fetchData()
                    .then((response) => {
                        if (validateResponse(response)) {
                            // response = JSON.parse(response);
                            setupTableOfContents(response);

                            oldData = response;
                        }
                    })
                    .then(() => {
                        fetchDataFromServer().then((newSettings) => {
                            let previousDate = new Date(oldData.updated);
                            let newDate = new Date(newSettings.updated);
                            //   taster.log(,)
                            // permanent cache ask for reload instanly on change settings
                            const hasChanges =
                                newDate > previousDate ? true : false; //@TODO: update next time with settings.

                            if (hasChanges) {
                                saveToLocalStorageWithExpiry(
                                    "etoc_settings",
                                    newSettings,
                                    30
                                );

                                Swal.fire({
                                    title: "<strong>Table of Content Settings has been updated</strong>",
                                    icon: "info",
                                    html: "Do you want to reload the page?",
                                    showCloseButton: true,
                                    showCancelButton: true,
                                    focusConfirm: false,
                                    confirmButtonText: " Reload",
                                    confirmButtonAriaLabel: "Thumbs up, great!",
                                    cancelButtonText: "Later",
                                    cancelButtonAriaLabel: "Thumbs down",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        location.reload();
                                    }
                                });
                            } else {
                                taster.log("Settings are unchanged.");
                            }
                        });
                    })
                    .catch((error) => {
                        console.error("Failed to load settings: ", error);
                    });
            }

            function validateResponse(response) {
                if (!response) {
                    console.log(
                        "Settings not saved for Easy table of Content App"
                    );
                    return false;
                }

                return true;
            }
            function saveToLocalStorageWithExpiry(key, value, days) {
                const now = new Date();
                // Calculate the expiry time
                const expiryDate = new Date(
                    now.getTime() + days * 24 * 60 * 60 * 1000
                );

                const item = {
                    value: value,
                    expiryDate: expiryDate.getTime(),
                };

                localStorage.setItem(key, JSON.stringify(item));
            }

            function getFromLocalStorageWithExpiry(key) {
                return new Promise((resolve, reject) => {
                    const now = new Date().getTime();
                    const itemStr = localStorage.getItem(key);
                    if (!itemStr) {
                        fetchDataFromServer()
                            .then((data) => {
                                resolve(data);
                            })
                            .catch((error) => {
                                reject(error);
                            });
                        return;
                    }

                    const item = JSON.parse(itemStr);

                    if (now > item.expiryDate) {
                        // If the item is expired, delete it from the storage and fetch new data
                        localStorage.removeItem(key);
                        fetchDataFromServer()
                            .then((data) => {
                                resolve(data);
                            })
                            .catch((error) => {
                                reject(error);
                            });
                        return;
                    }

                    resolve(item.value);
                });
            }

            function fetchDataFromServer() {
                return new Promise((resolve, reject) => {
                    // For simplicity, using the Fetch API. Replace this with your preferred AJAX method.
                    $.ajax({
                        type: "get",
                        url: taster.debug
                            ? `https://rnd-local.test/data.json`
                            : `https://cdn.shopify.com/s/files/1/0887/5406/1634/files/dd.json?v=1726027868`,
                        headers: { "Access-Control-Allow-Origin": "*" },
                        success: function (response) {
                            if (response.parmanentCache == "yes") {
                                saveToLocalStorageWithExpiry(
                                    "etoc_settings",
                                    response,
                                    30
                                );
                            }

                            resolve(response);
                        },
                        error: function (error) {
                            reject(error);
                        },
                    });
                });
            }

            function fetchData() {
                return new Promise((resolve, reject) => {
                    getFromLocalStorageWithExpiry("etoc_settings")
                        .then((etocSettings) => {
                            resolve(etocSettings);
                        })
                        .catch((error) => {
                            console.error("Error fetching data:", error);
                        });
                });
            }
            function setupTableOfContents(response) {
                const config = buildConfig(response);
                const escapedArray = getEscapedArray(config);
                if (shouldSkipRendering(escapedArray)) return;
                taster.log("Is .toc available?", $.fn.toc);
                renderTableOfContents(config);
                // stickyTocSetUp(response); // for next version on check
                applyStylesFromResponse(response);
                positionTableOfContents(config, response);
                if (config.foldable == "yes") {
                    foldToc();
                }
            }

            function buildConfig(response) {
                const defaultConfig = {
                    headings: "h2,h3,h4,h5,h6", //elements to use as headings
                    content: "", //element to find all selectors in
                    ignoreBlank: "yes",
                    foldable: "yes",
                    floated_postion: "top-right",
                    // prefix: "tocs", //prefix for anchor tags and class names
                    highlightOnScroll: true, //add class to heading that is currently in focus
                    highlightOffset: 100, //offset to trigger the next headline
                    indexing: false,

                    onHighlight: function (el) {}, //called when a new section is highlighted,
                    beforeScroll: (options) => {
                        //#easy-table-of-content don't have class fixed then find the outer height of this and add it to the offset . if existing height is minus then it will be  add with minus other wise plus

                        if (
                            !$("#easy-table-of-content").hasClass("fixed") &&
                            response.position == "floated"
                        ) {
                            var outerHeight = $(
                                "#easy-table-of-content"
                            ).outerHeight();
                            options.offset +=
                                outerHeight < 0 ? outerHeight : -outerHeight;
                        }
                        taster.log(options);
                    },
                    afterScroll: (options) => {
                        taster.log(options);
                    },
                    anchorName: function (i, heading, prefix) {
                        //custom function for anchor name
                        return prefix + i;
                    },
                    headerText: function (i, heading, $heading) {
                        //custom function building the header-item text
                        return $heading.text();
                    },
                    itemClass: function (i, heading, $heading, prefix) {
                        // custom function for item class
                        return $heading[0].tagName.toLowerCase();
                    },
                };

                response.headings = response.headings.join(",");
                response.indexing = ["numeric", "decimal"].includes(
                    response.countType
                );
                response.content = getContentFromResponse(response);

                return $.extend({}, defaultConfig, response);
            }

            function getContentFromResponse(response) {
                const analyzer = new ArticlePageAnalyzer(
                    response.headings ?? "h2,h3,h4,h5,h6",
                    "easy-table-of-content"
                );
                return (
                    response.postWrapper ||
                    response.customizeThemeContainer ||
                    analyzer.analyze() ||
                    ".rte"
                );
            }

            function getEscapedArray(config) {
                return config.hasOwnProperty("escaped") &&
                    config.escaped !== null
                    ? config.escaped.split(",")
                    : [];
            }

            function shouldSkipRendering(escapedArray) {
                return (
                    typeof ShopifyAnalytics !== "undefined" &&
                    escapedArray.includes(
                        ShopifyAnalytics.meta.page.resourceId.toString()
                    )
                );
            }

            function renderTableOfContents(config) {
                $("ul#easy-table-of-contents").hide();

                if ($("ul#easy-table-of-content").length < 1) {
                    $(config.content).prepend(
                        '<ul id="easy-table-of-content"></ul>'
                    );
                }
                taster.log(config);

                $("#easy-table-of-content").toc(config);
                //hide if no headings
                //hide if no headings
                $("ul#easy-table-of-content").each(function () {
                    if ($(this).find("li").length === 0) {
                        $(this).hide();
                    }
                });
            }

            function applyStylesFromResponse(response) {
                const css = `
                #easy-table-of-content {
                    background-color: rgb(${response.style.background});
                    border-color: rgb(${response.style.border});
                }
                #easy-table-of-content .title {
                    color: rgb(${response.style.title});
                }
                #easy-table-of-content li a {
                    color: rgb(${response.style.link});
                }
                #easy-table-of-content li a:hover {
                    color: rgb(${response.style.hover});
                }
                #easy-table-of-content li a:visited {
                    color: rgb(${response.style.visited});
                }
                ${response.customStyle}
            `;

                const styleElement = document.createElement("style");
                styleElement.type = "text/css";
                styleElement.appendChild(document.createTextNode(css));
                document.head.appendChild(styleElement);
            }

            function positionTableOfContents(config, response) {
                const firstHeading = findFirstHeading(config);

                if (!firstHeading) return;

                if (
                    response.position === "destinationSelector" &&
                    isDeviceWidthGreaterThan(990) //@TODO: make it configurable
                ) {
                    let selector = response.destinationSelector;
                    let selectorPosition = response.destinationSelectorPosition;
                    if (isCssSelector(selector)) {
                        selector = $(selector);
                        if (selector.length) {
                            //if append selected otherwise whatevrValue it will be prepend
                            if (selectorPosition === "append") {
                                selector.append($("#easy-table-of-content"));
                            } else {
                                selector.prepend($("#easy-table-of-content"));
                            }
                        }
                    }
                }
                if (response.position === "floated") {
                    // Create a debounce function
                    function debounce(func, wait) {
                        let timeout;
                        return function () {
                            let context = this,
                                args = arguments;
                            clearTimeout(timeout);
                            timeout = setTimeout(function () {
                                func.apply(context, args);
                            }, wait);
                        };
                    }
                    // Create a placeholder element with inline CSS
                    let placeholder = $('<div id="toc-placeholder"></div>');
                    // Wrap your scroll event handler in the debounce function
                    $(window).scroll(
                        debounce(function () {
                            let articleContainer = document.querySelector(
                                response.content
                            );
                            let sideToc = $("#easy-table-of-content");
                            let articleRect =
                                articleContainer.getBoundingClientRect();
                            let sideTocHeight = sideToc.height();

                            let adjustedTop = articleRect.top + sideTocHeight;
                            let offset = 100; // Adjust this value as needed
                            let adjustedBottom =
                                articleRect.bottom - sideTocHeight - offset;

                            if (adjustedTop <= 0 && adjustedBottom >= 0) {
                                placeholder
                                    .insertBefore(sideToc)
                                    .height(sideTocHeight);
                                sideToc.addClass(
                                    response.floated_postion + " fixed"
                                );
                            } else {
                                placeholder.remove();
                                sideToc.removeClass(
                                    response.floated_postion + " fixed"
                                );
                            }
                        }, 200)
                    ); // 200ms debounce time
                }

                if (response.position === "afterHeading") {
                    $("#easy-table-of-content").insertAfter(firstHeading);
                } else if (response.position === "beforeHeading") {
                    $("#easy-table-of-content").insertBefore(firstHeading);
                }

                if (response.indent === "no") {
                    $("#easy-table-of-content").addClass("no-indent");
                }
            }

            function stickyTocSetUp(response) {
                let $toc = $("#easy-table-of-content"),
                    $postContent = $(response.postWrapper),
                    tocInitialOffset = $toc.offset().top;
                tocFolded = false; // Add this flag
                $(window).scroll(function () {
                    var windowScrollTop = $(window).scrollTop(),
                        postOffsetTop = $postContent?.offset().top,
                        postOffsetBottom =
                            postOffsetTop + $postContent.height() ;
                    //Sticky is not Usable for current Version. Only done for future one
                    if (response.position == "sticky") {
                        //   taster.log(response);
                        $toc.addClass(response.floated_postion);
                        if (
                            windowScrollTop > tocInitialOffset &&
                            windowScrollTop <= postOffsetBottom - $toc.height()
                        ) {
                            // If scrolling past the initial TOC position but still within the post, make TOC fixed
                            $toc.removeClass("relative").addClass("fixed");
                            if (!tocFolded) {
                                // Ensure foldToc() is called only once when toc becomes fixed
                                foldToc();

                                tocFolded = true;
                            }
                        } else {
                            // If scrolled above the initial TOC position
                            $toc.removeClass("fixed").addClass("relative");
                            tocFolded = false;
                        }
                    }
                });
            }

            function findFirstHeading(config) {
                const tags = ["h1", "h2", "h3", "h4", "h5"];
                for (let tag of tags) {
                    let heading = $(config.content)
                        .find(tag)
                        .not(".title")
                        .eq(0);
                    if (heading.length) {
                        return heading;
                    }
                }
                return null;
            }
        })(jQueryNoConflict);
        taster.log("All scripts loaded!");
    });
}

function loadScriptsSequentially(scripts, callback) {
    const totalScripts = scripts.length;
    function loadScript(index) {
        if (index === totalScripts) {
            callback();
            return;
        }

        const script = document.createElement("script");
        script.src = scripts[index];
        script.onload = () => loadScript(index + 1);
        document.body.appendChild(script);
    }

    loadScript(0);
}
//check param is it a css selector
function isCssSelector(selector) {
    try {
        document.querySelector(selector);
        return true; // No error means it's a valid selector
    } catch (e) {
        console.log(e);
        return false; // An error means it's not a valid selector
    }
}

function isDeviceWidthGreaterThan(pixel) {
    return window.innerWidth > pixel;
}
